<template>
  <div class="user-declare lesson-tab-box">
    <div class="right-btn">
      <el-button class="add-lesson-btn" type="primary" icon="el-icon-plus" size="small" @click="declareAdd">
        创建申报实验
      </el-button>
    </div>
    <el-tabs>
      <el-tab-pane label="申报实验">
        <div class="declare-list">
          <el-row v-for="item in list" :key="item.id" class="declare-item">
            <el-col :span="17" class="declare-main">
              <el-row :gutter="24">
                <el-col :span="7">
                  <el-image fit="cover" :src="item.imgUrl | filterUrl">
                    <div class="image-placeholder" slot="placeholder">
                      <i class="el-icon-loading"></i>
                    </div>
                    <div class="image-error" slot="error">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-col>
                <el-col :span="17" class="declare-info">
                  <div>
                    <h4>
                      <span>{{ item.title }}</span>
                      <el-tag size="mini" :type="item.status?'primary':'warning'" style="margin-left:12px">
                        {{ item.status ? '已发布' : '未发布' }}
                      </el-tag>
                    </h4>
                  </div>
                  <div>
                    <p>
                      <i>组织机构 :</i>
                      <span>{{ item.schoolTitle }}</span>
                    </p>

                  </div>
                  <div>
                    <p>
                      <i>负责人 :</i>
                      <span>{{ item.inchargeName }}</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      <i>网址 : </i>
                      <span>{{ `${baseUrl}${path}edu/${item.keyUrl}` }}</span>
                    </p>
                  </div>
                  <p class="create-time">
                    <span>
                        {{ `创建时间:${item.createTime}` }}
                    </span>
                  </p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4" class="declare-exp">
              <h4>实验数量</h4>
              <p>
                <el-button round :style="{fontSize:'20px'}" @click="getLookExp(item)">{{ item.expCount }}</el-button>
              </p>
            </el-col>
            <el-col :span="3" class="declare-action">
              <p>
                <el-dropdown @command="handleCommand($event,item)" trigger="click">
                  <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">基本信息</el-dropdown-item>
                    <el-dropdown-item command="page">页面配置</el-dropdown-item>
                    <el-dropdown-item command="api">对接配置</el-dropdown-item>
                    <el-dropdown-item command="remove">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </p>
              <el-button type="primary" size="small" @click="handProject(item)">进入申报</el-button>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper"
                   :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount"
                   @current-change="handPageChange" style="margin-top:15px"></el-pagination>

    <el-dialog :destroy-on-close="true" :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible"
               width="50%">
      <component :is="tabs[active]" :shenbaoId="shenbaoId" @close="close"/>
    </el-dialog>
  </div>
</template>
<script>
import {baseUrl, path} from "@/config/env";
import {open_blank} from '@/utils/router'
import {getList, removeByID} from '@/api/shenbao/shenbao'
import {mapGetters} from 'vuex'
import shenbao from '@/views/declare/shenbao'
import shenbaoPage from '@/views/declare/shenbao-page'
import shenbaoApi from '@/views/declare/shenbao-api'
import shenbaoContent from '@/views/declare/shenbao-content'

export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      tabs: {
        'edit': shenbao,
        'page': shenbaoPage,
        'api': shenbaoApi,
        'content': shenbaoContent
      },
      active: '',
      baseUrl: '',
      path: '',
      form: {},
      page: {
        page: 1,
        limit: 5,
        total: 0
      },
      list: [],
      shenbaoId: '',
      flag: false
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 50) {
        return value.slice(0, 50) + "...";
      }
      return value;
    }
  },
  components: {
    shenbao,
    shenbaoPage,
    shenbaoApi,
    shenbaoContent,
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.init()
    this.baseUrl = baseUrl
    this.path = path
  },
  methods: {
    getLookExp(row) {
      const {id} = row
      this.$router.push(`/shenbaoexp/${id}`)
    },
    close() {
      this.shenbaoId = ''
      this.dialogVisible = false
      this.getDeclareList()
    },
    init() {
      this.getDeclareList()
    },
    handleCommand(key, row) {
      switch (key) {
        case 'edit':    //基本设置
          this.title = '基本配置'
          this.active = 'edit'
          this.shenbaoId = row.id.toString()
          this.dialogVisible = true
          // this.$refs['shenbao'].changeVisible(true)
          break
        case 'page':
          this.title = '页面配置'
          this.active = 'page'
          this.shenbaoId = row.id.toString()
          this.dialogVisible = true
          break
        case 'api':
          this.title = '对接配置'
          this.active = 'api'
          this.shenbaoId = row.id.toString()
          this.dialogVisible = true
          break
        case 'remove':
          this.$confirm("此操作将删除该选项, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
              .then(() => {
                removeByID(row.id).then(() => {
                  this.$message.success("删除成功!");
                  this.getDeclareList();
                });
              })
              .catch(() => {
              });
          break
      }
    },
    getDeclareList() {
      const {page, limit} = this.page
      const {userInfo} = this
      getList(page, limit, {
        inchargeId: userInfo.id
      })
          .then(res => {
            const {totalCount, list} = res
            this.$set(this.page, 'total', totalCount)
            this.list = list
          })
    },
    handPageChange(page) { //点击切换分页
      this.$set(this.page, 'page', page)
      this.getDeclareList()
    },
    declareAdd() {   //编辑或者添加
      this.active = 'edit'
      this.shenbaoId = null
      this.dialogVisible = true
    },
    handProject(item) {
      open_blank({
        name: 'shenbaoV1',
        params: {
          key: item.keyUrl
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.user-declare {
  .right-btn {
    z-index: 998;
  }

  .declare-item {
    margin: 20px 0;
    padding: 10px 0;
    border-bottom: 1px solid #efefef;
  }

  .declare-info {
    .create-time {
      font-size: 12px;
      text-align: left;
    }

    div {
      margin-bottom: 6px;
      font-size: 18px;

      p {
        font-size: 14px;

        i {
          font-style: normal;
          color: #666;
        }

        span {
          color: #777
        }
      }
    }
  }

  .course-img {
    width: 180px;
    height: 105px;
  }

  .upload-bg-img {
    li {
      float: left;
      margin-left: 12px;
    }

    .custom-upload {
      width: 180px;
      cursor: pointer;
      background-color: #e0dddd;
      line-height: 105px;
      text-align: center;
    }

    input {
      display: none;
    }
  }

  .declare-action {
    text-align: right;

    .el-button {
      margin-top: 60px
    }
  }

  .declare-exp {
    text-align: center;

    p {
      padding: 24px 0;
    }
  }

  .user-declare-tab {
    .wangeditor-box {
      height: 400px;
    }
  }
}
</style>
<style lang="less">
.user-declare {
  .user-declare-tab {
    .w-e-toolbar {
      overflow: visible;
    }
  }
}
</style>